<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    import UIModulePartEmpty from "./modules.part.empty.svelte";
    export let formatModuleID;
    export let value = [];
    export let showLabels = false;
</script>

<a
    class="module-calc-library-variant"
    on:click|preventDefault={() => dispatch("click", formatModuleID)}
>
    {#if showLabels}
        <span class="centered-label">{formatModuleID}</span>
    {/if}
    <p>
        {#each value as moduleValue}
            <UIModulePartEmpty {...moduleValue} {formatModuleID}
            ></UIModulePartEmpty>
        {/each}
    </p>
</a>
